export const ADVISOR_SERVICE = '/api/v1/advisor';
export const ADVISOR_INSTRUCTION_SERVICE = '/api/v1/advisorinstruction';
export const DOCUMENT_SERVICE = '/api/v1/document';
export const STATE_SERVICE = '/api/v1/state';
export const USER_SERVICE = '/api/v1/user';
export const CONSENT_SERVICE = '/api/v1/consent';
export const ACCOUNT_SERVICE = '/api/v1/account';
export const DISTRIBUTOR_SERVICE = '/api/v1/distributor';
export const FUND_SERVICE = '/api/v1/fund';
export const BANK_SERVICE = '/api/v1/bank';
export const AUTH_SERVICE = '/api/v1/authorisation';
export const MESSAGE_SERVICE = '/api/v1/message';
export const TRANSCRIPT_SERVICE = '/api/v1/transcript';
export const INVESTOR_SERVICE = '/api/v1/investor';
export const NOTIFICATION_SERVICE = '/api/v1/notification';
export const MEETING_SERVICE = '/api/v1/meeting';
export const DIARY_SERVICE = '/api/v1/diary';
export const FACT_FIND_SERVICE = '/api/v1/factfind';
export const ILLUSTRATION_SERVICE = '/api/v1/illustration';
export const QUERY_SERVICE = '/api/v1/query';
export const TASK_SERVICE = '/api/v1/task';
export const VECTOR_SERVICE = '/api/v1/wp-vectoriser-service';
export const ADDRESS_SERVICE = '/api/v1/address';
export const REPORT_SERVICE = '/api/v1/report';
export const REPORTBUILD_SERVICE = '/api/v1/reportbuild';
export const PORTFOLIO_SERVICE = '/api/v1/portfolio';
export const WP_PORTFOLIO_SERVICE = '/api/v1/wp-portfolio-metrics';
export const WORKFLOW_SERVICE = '/api/v1/workflow';
export const FINANCIAL_PLANNING_SERVICE = '/api/v1/financial-planning';
export const FINANCIAL_MIS_SERVICE = '/api/v1/financial-mis';
export const FACT_FINDING_SERVICE = '/api/v1/wp-fact-finding';
export const BILLING_SERVICE = '/api/v1/billing';
export const CREDITS_SERVICE = '/api/v1/credits';
export const AI_INTERACTION_SERVICE = '/api/v1/ai-interaction';
export const QUIN_ADAPTER_SERVICE = '/api/v1/qkvin-adaptor';
export const AI_REPORTING_SERVICE = '/api/v1/ai-reporting';
export const WP_DOCUMENT_QA = '/api/v1/wp-document-qa';
export const DOCUMENT_PROCESSOR_SERVICE = '/api/v1/wp-document-processor-service';
export const LLM_SERVICE = '/api/v1/llm';
export const COMPLIANCE_SERVICE = '/api/v1/compliance';
export const CLIENT_ADVICE_SERVICE = '/api/v1/client-advice';
export const ADVISOR_INTELLIGENCE_SERVICE = '/api/v1/intelligence';
export const MPS_SERVICE = '/api/v1/mps';
export const TRAINING_VIDEO_SERVICE = '/api/v1/zeta-support-svc';
export const SUPPORT_TICKET_SERVICE = '/api/v1/support';
export const OPERATIONS_SERVICE = '/api/v1/operations';
export const QUIN_CASE_SERVICE = '/api/v1/cases';

export const ErrorStatusCodes = [501, 502, 503, 504];

export const ServerErrorMessage = `Temporary server issue. Please refresh or try again soon`;
